import { IApiResponse, ISubmittedData } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class SubmittedDataService extends BaseService {
  public getSubmittedData = async (dateFrom: Date | null, dateTo: Date | null) : Promise<Array<ISubmittedData>> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/GetSubmittedData/${this.siteKey}`;
      const data = {
        datefrom: dateFrom,
        dateto: dateTo
      };

      const res = await this._ajaxService.Post<IApiResponse>(url, data, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve site submitted data");
        }
      }
    }
    return [];
  }
}